import React, { ReactElement } from 'react';
import * as S from './loading.styled';
import { useTranslations } from '../../../../translations';
import { CustomersSubscriptionPopupTitle } from '../../customersSubscriptionPopup.styled';

export const Loading = (): ReactElement => {
  const translations = useTranslations();
  return (
    <S.Loading>
      <S.LoaderDots>
        <S.LoaderDotsItem key={'dots-item-1'} />
        <S.LoaderDotsItem key={'dots-item-2'} />
        <S.LoaderDotsItem key={'dots-item-3'} />
      </S.LoaderDots>
      <CustomersSubscriptionPopupTitle>
        {translations.request_processing}
      </CustomersSubscriptionPopupTitle>
    </S.Loading>
  );
};
